// extracted by mini-css-extract-plugin
export default {"timeSpan":"ukSYgoZVQk","icon":"gbaz6MB_8E"};